import { EditOutlined } from "@ant-design/icons";
import { Checkbox } from "components/common";

export const columns = [
  {
    title: <Checkbox />,
    render: () => (
      <a>
        <Checkbox />
      </a>
    ),
  },
  {
    title: "Date",
    dataIndex: "datePaid",
  },
  {
    title: "Install",
    dataIndex: "installCommission",
  },

  {
    title: "CAP",
    dataIndex: "CAPPayment",
  },
  {
    title: "ClawBack/Bonus",
    dataIndex: "clawbackBONUS",
  },
  {
    title: "Total Paid in Period",
    dataIndex: "totalinPeriod",
  },
  {
    title: "Total Project Commission",
    dataIndex: "totalProjectCommission",
  },
  {
    title: "Action",
    render: () => (
      <a>
        <EditOutlined />
      </a>
    ),
  },
];

export const data = [
  {
    key: "1",
    date: "12 AUGUST 2022",
    install: "Completed",
    cap: "10%",
    bonus: "2.5%",
    totalPaid: "$1100",
    projectCommission: "$100",
  },
  {
    key: "2",
    date: "22 JULY 2022",
    install: "Pending",
    cap: "6.3%",
    bonus: "0.5%",
    totalPaid: "$740",
    projectCommission: "$60",
  },
  {
    key: "3",
    date: "10 JAN 2022",
    install: "Completed",
    cap: "11%",
    bonus: "1.5%",
    totalPaid: "$7000",
    projectCommission: "$380",
  },
  {
    key: "4",
    date: "12 AUGUST 2022",
    install: "Completed",
    cap: "10%",
    bonus: "2.5%",
    totalPaid: "$1100",
    projectCommission: "$100",
  },
];
